import { getValueFromSearchParam } from '../utils/url';
import { SpaceBetween } from '@amzn/awsui-components-react';
import Container from '@amzn/awsui-components-react/polaris/container';
import { useLocalizedText } from '../hooks/localizedText';
import { useSearchParams } from 'react-router-dom';
import { AmbassadorBulkUpdateDisplay } from '../components/ambassadors/ambassadorBulkUpdateDisplay';
import { AmbassadorBulkUpdateForm } from '../components/ambassadors/ambassadorBulkUpdateForm';
import { featureIsEnabled, useFeatures } from '../hooks/features';
import { COMMUNITY_AMBASSADOR_FEATURE_FLAG } from '../utils/constants';
import { useState } from 'react';
import { BulkUpsertAmbassadorsCommandOutput } from '@amzn/red-velvet-api';

export function AmbassadorBulkUpdator() {
  const [searchParams] = useSearchParams();
  const filename = getValueFromSearchParam(searchParams, 'filename');
  const { t } = useLocalizedText(['ambassadors', 'translation']);
  const [uploadResult, setUploadResult] = useState<BulkUpsertAmbassadorsCommandOutput | undefined>(
    undefined
  );

  const fileHasBeenSubmitted = filename !== '';

  return (
    <Container fitHeight variant="stacked">
      <h1>{t('bulkUpdate.ambassadors.title')}</h1>
      <SpaceBetween direction="vertical" size="m">
        {fileHasBeenSubmitted && uploadResult ? (
          <AmbassadorBulkUpdateDisplay update={uploadResult} />
        ) : (
          <AmbassadorBulkUpdateForm setUploadResult={setUploadResult} />
        )}
      </SpaceBetween>
    </Container>
  );
}

export function AmbassadorBulkUpdateView() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();

  if (featureIsEnabled(COMMUNITY_AMBASSADOR_FEATURE_FLAG, features, searchParams)) {
    return <AmbassadorBulkUpdator />;
  }
  return <></>;
}
